<template>
  <div class="tourHome relative h-full">
    <ParallelEditErrorModal></ParallelEditErrorModal>
    <TourOverview
      v-if="store?.state?.OrderStore?.tours.length"
      :tours="store?.state?.OrderStore?.tours"
    ></TourOverview>
    <div class="absolute z-1 inset-0 flex items-center justify-center" v-else>
      <span class="text-gray-500 w-40">{{ $t("tour.empty") }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref } from "vue";
import { useStore } from "vuex";
import TourOverview from "@/components/tours/TourOverview.vue";
import { reAuthorize } from "@/services/auth/re-auth";
import ParallelEditErrorModal from "@/components/ParallelEditErrorModal.vue";

export default defineComponent({
  name: "HomeView",
  setup() {
    const store = useStore();

    const startFetchingOrders = () => {
      store.dispatch("OrderStore/getTours");

      const intervalId = setInterval(() => {
        store.dispatch("OrderStore/getTours");
      }, 60000);

      return intervalId;
    };

    let fetchOrdersInterval = 0 as number;

    onMounted(() => {
      reAuthorize(store).then((res) => {
        fetchOrdersInterval = startFetchingOrders();
      });
    });

    onBeforeUnmount(() => {
      clearInterval(fetchOrdersInterval);
    });

    return {
      store,
    };
  },
  components: {
    TourOverview,
    ParallelEditErrorModal,
  },
});
</script>
